import * as _ from 'lodash';
import { IPaginatorCtrl } from "../paginator.component";
import { IFilterSetting, FilterSettingMode, FilterDataType, IFilterSettingConfigValue, IFilterSettingConfigDatetime } from "../../capture-filter-range/capture-filter-range.component"
import { Subject } from 'rxjs';
import moment from 'moment';
export const STANDARD_PAGE_SIZE = 10;
export enum SortMode { // compatible with lodash sort
  NONE = '',
  ASC = 'asc',
  DESC = 'desc',
}
export const strIncludes = (needle:string, haystack:string) => {
  needle = (''+(needle || '')).toLowerCase();
  if (haystack){
    haystack = (''+haystack).toLowerCase()
    return _.includes(haystack, needle);  
  }
}

interface IConfig<T> {
  data: T[],
  pageSize?:number,
  configurablePageSize?: boolean;
  // allowNewSortSettings:boolean,
  sortSettings?: {
    [key:string]: SortSetting,
  },
  filterSettings?: {
    [key:string]: FilterCheckFunction
  }
}
type FilterCheckFunction = (entry:any, filter:string) => boolean;
type SortFunction = (entry:any) => string | boolean;
type SortSetting = string | SortFunction; // either sort by element prop or a function
interface ISortSetting {
  id: string,
  sortSetting: SortSetting,
  mode: SortMode,
}

export class MemDataPaginated<T>  {

  private data: T[];
  private paginator: IPaginatorCtrl;
  private currentPageData = [];
  private sortSettings:ISortSetting[] = [];
  public activeFilters:{[key:string]: IFilterSetting} = {};
  
  // filterUpdate:Subject<boolean> = new Subject();
  // public get filterChanges() : string {
  //   return this.filterUpdate;
  // }
  

  constructor(private config:IConfig<T>){
    this.paginator = {
      pageSize: config.pageSize || STANDARD_PAGE_SIZE,
      configurablePageSize: config.configurablePageSize,
      loadNewData: (numSkip:number) => this.refreshPageSelection(numSkip)
    }
    this.injestNewData(config.data);
  }

  public injestNewData(data:any[]){
    this.data = data.concat([]);
    this.refreshSort();
  }

  refresh(){
    this.refreshPageSelection((this.paginator.currentPage-1) * this.paginator.pageSize)
  }

  public refreshFilters(){ this.refreshSort(); }
  private refreshSort(){
    let data = this.data;
    data = this.applyAllFilters(data);
    data = this.applyAllSorts(data);
    this.config.data = data;
    this.refresh();
  }

  getFilteredData(){
    return this.config.data;
  }

  numEntries(){
    return this.config.data.length;
  }

  private applyAllFilters(data:T[]){
    if (!this.config.filterSettings){
      this.config.filterSettings = {};
    }
    Object.keys(this.activeFilters).forEach(id => {
      const filter:IFilterSetting = this.activeFilters[id];
      if (filter){
        const filterSetting = this.config.filterSettings[id];
        if (filter.mode === FilterSettingMode.VALUE){
          const filterConfig = <IFilterSettingConfigValue> filter.config
          let filterValue:string = filterConfig.value;
          if (filterValue){
            if (typeof filterSetting === 'function'){
              data = _.filter(data, entry => filterSetting(entry, filterValue) );
            }
            else{
              data = _.filter(data, entry => {
                const entryVal:string | number = entry[id];
                if (typeof entryVal === 'number'){
                  let found = false;
                  const entryValStr = entryVal.toString();
                  for (let i = 0; i < filterValue.length; i++) {
                    if(entryValStr[i] !== filterValue[i]) {
                      return found;
                    }
                  }
                  found = true;
                  return found;
                }
                else if (moment.isMoment(entryVal)) {
                  return strIncludes(filterValue, moment(entryVal).format("dddd, MMMM Do YYYY, h:mm"));
                }
                else{
                  return strIncludes(filterValue, entryVal)
                }
              });
            }
          }
        } else if (filter.mode === FilterSettingMode.RADIO) {
          const filterConfig = <IFilterSettingConfigValue> filter.config
          let filterValue = filterConfig.selected;
          data = _.filter(data, entry => {
            const entryVal:Object = entry[id];
            if (filterValue) return entryVal !== null;
            else if (filterValue === null) return data;
            else return entryVal === null;
          })
        } else if (filter.mode === FilterSettingMode.DATETIME) {
          const filterConfig = <IFilterSettingConfigDatetime> filter.config
          const dateFrom = !filterConfig.dateFrom ? null : filterConfig.dateFrom;
          const dateTo = !filterConfig.dateTo ? null : filterConfig.dateTo;
          const timeFrom = !filterConfig.timeFrom ? null : filterConfig.timeFrom;
          const timeTo = !filterConfig.timeTo ? null : filterConfig.timeTo;
          
          if(dateFrom && dateTo && timeFrom && timeTo) {
            const dateTimeFrom = this.convertDateAndTimeToDatetime(dateFrom, timeFrom);
            const dateTimeTo = this.convertDateAndTimeToDatetime(dateTo, timeTo);
            data = _.filter(data, entry => {
              const entryVal = entry[id];
              return (moment(entryVal).isBefore(dateTimeTo) || moment(entryVal).isSame(dateTimeTo)) && (moment(entryVal).isAfter(dateTimeFrom) || moment(entryVal).isSame(dateTimeFrom));
            })
          }
        }
      }
    });
    return data;
  }

  private applyAllSorts(data:T[]){
    this.sortSettings.forEach(sortSetting =>{
      if (typeof sortSetting.sortSetting === 'string'){
        // to do when a use case appears
        const prop = <string> sortSetting.sortSetting;
        data = _.orderBy(data, entry => (''+entry[prop]).toLowerCase(), sortSetting.mode);
      }
      else if (typeof sortSetting.sortSetting === 'function'){
        // to do when a use case appears
        const propExtractor:Function = sortSetting.sortSetting;
        data = _.orderBy(data, entry => propExtractor(entry), sortSetting.mode);
      }
      else {
        
      }
    });
    return data;
  }

  private currentNumSkip:number;
  private refreshPageSelection(numSkip:number){
    if(numSkip < 0){
      numSkip = 0
    }
    this.currentNumSkip = numSkip;
    return new Promise((resolve, reject) => {
      this.currentPageData = this.config.data.slice( numSkip, numSkip + this.paginator.pageSize);
      // console.log('numSkip', numSkip, this.config.data.length, this.paginator.pageSize, this.currentPageData)
      this.paginator.totalRecords = this.config.data.length,
      resolve();
    })
  }


  private getSortSetting(id:string){
    return this.sortSettings.filter(setting => setting.id === id)[0];
  }
  
  public getSortSettingMode(id:string):SortMode{
    const sortSetting = this.getSortSetting(id);
    if (sortSetting){
      return sortSetting.mode;
    }
    return SortMode.NONE;
  }
  
  toggleSortSetting(id:string){
    let sortSetting = this.getSortSetting(id);
    if (!sortSetting){
      sortSetting = this.addSortSetting(id);
    }
    const currentSetting = this.getSortSettingMode(id);
    switch(currentSetting){
      case SortMode.DESC: this.removeSortSetting(id); break;
      case SortMode.ASC:  sortSetting.mode = SortMode.DESC; break;
      default:
      case SortMode.NONE: sortSetting.mode = SortMode.ASC;  break;
    }
    this.refreshSort();
  }

  private addSortSetting(id:string, mode?: SortMode, sortSetting?:SortSetting){
    this.removeSortSetting(id);
    mode = mode || SortMode.NONE;
    sortSetting = sortSetting || this.config.sortSettings[id];
    if ( !(sortSetting || typeof sortSetting === 'function') ) {
      sortSetting = id;
    }
    const sortSettingEntry = { id, mode, sortSetting };
    this.sortSettings.push(sortSettingEntry);
    return sortSettingEntry;
  }

  private removeSortSetting(id:string){
    this.sortSettings = this.sortSettings.filter(setting => setting.id !== id)
  }

  public getPaginatorCtrl(){
    return this.paginator;
  }

  gotoEntryPage(entry:any){
    const i = this.config.data.indexOf(entry);
    const pageIndex = Math.floor((i+1) / this.paginator.pageSize);
    this.paginator.currentPage = pageIndex+1;
    this.refresh();
  }

  public getPage(){
    return this.paginator.currentPage;
  }

  getRelativeOrdinal(index:number){
    return  ((this.paginator.currentPage-1)*this.paginator.pageSize) + index + 1
  }

  public getCurrentPageData(){
    return this.currentPageData;
  }

  private convertDateAndTimeToDatetime (dateObj, timeObj) {
    const month = dateObj.month < 10 ? `0${dateObj.month}` : dateObj.month;
    const day = dateObj.day < 10 ? `0${dateObj.day}` : dateObj.day;
    const hour = timeObj.hour < 10 ? `0${timeObj.hour}` : timeObj.hour;
    const min = timeObj.minute < 10 ? `0${timeObj.minute}` : timeObj.minute;
    const second = timeObj.second < 10 ? `0${timeObj.second}` : timeObj.second;
    let dateString = `${dateObj.year}-${month}-${day} ${hour}:${min}:${second}`
    // console.log(dateString);
    return moment(dateString, "YYYY-MM-DD hh:mm:ss")
  }
}
